import * as types from '../mutation-types';
import BigNumber from 'bignumber.js';
import User from '../../classes/user';
import store from '../index';

/* eslint-disable no-process-env */
/* eslint-disable indent */
const stateData = {
          balance:             new BigNumber('20'),
          lifetimeEarnings:    new BigNumber('0'),
          sessionEarnings:     new BigNumber('0'),
          showIncomePerSecond: false,
          onStrike:            false,
          strikeDuration:      0,
          version:             0,
          points:              0,
          key:                 null,
          buildIncrement:      1,
          hideAppliedUpgrades: false,
          hideAchieved:        false,
          productionQueue:     [],
          soundEnabled:        false,
          statsID:             null,
          language:            'de',
          user:                new User(),
          isInitialized:       false,
          doReset:             false,
          apiURL:              process.env.NODE_ENV === 'production'
              ? 'https://vuemeanager.moches.de'
              : `http://${process.env.HOST || 'localhost'}:3000`
      },
      getters   = {
          totalBalance:   state => state.balance,
          queue:          state => state.productionQueue,
          soundEnabled:   state => state.soundEnabled,
          user:           state => state.user,
          initialization: state => state.isInitialized,
          hideApplied:    state => state.hideAppliedUpgrades,
          hideAchieved:   state => state.hideAchieved,
          points:         state => state.points
      },
      actions   = {
          setBuildIncrement({ commit }, increment) {
              commit('SET_BUILD_INCREMENT', increment);
          }
      },
      mutations = {
          [types.SAVE_GAME](state) {
          },
          [types.INCREASE_BALANCE](state, { amount }) {
              if (typeof amount !== 'undefined') {
                  state.balance = state.balance.plus(amount);
                  state.lifetimeEarnings = state.lifetimeEarnings.plus(amount);
                  state.sessionEarnings = state.sessionEarnings.plus(amount);
                  if (state.buildIncrement === -1) {
                      store.state.shops.all.forEach(s => {
                          s.calcMaxAmount(state.balance).then(res => {
                              store.commit(types.SET_MAX_AMOUNT, { shop: s, amount: res });
                          });
                      });
                  }
              }
          },
          [types.DECREASE_BALANCE](state, { amount }) {
              state.balance = state.balance.minus(amount);
              if (state.buildIncrement === -1) {
                  store.state.shops.all.forEach(s => {
                      store.commit(types.SET_MAX_AMOUNT, { shop: s, amount: s.getMaxAffordableAmount(state.balance) });
                  });
              }
          },
          [types.SET_BALANCE](state, { amount }) {
              state.balance = amount;
          },
          [types.SET_LIFETIME_EARNINGS](state, { amount }) {
              state.lifetimeEarnings = amount;
          },
          [types.SET_VERSION](state, { version }) {
              state.version = version;
          },
          [types.SET_KEY](state, { key }) {
              state.key = key;
          },
          [types.SET_LANGUAGE](state, { language }) {
              state.language = language;
          },
          [types.SET_POINTS](state, { points }) {
              state.points = points;
          },
          [types.SET_BUILD_INCREMENT](state, newIncrement) {
              state.buildIncrement = newIncrement;
          },
          [types.CLEANUP_QUEUE](state, { index, currentQueueEntry }) {
              currentQueueEntry.shop.productionProgress = 0;
              currentQueueEntry.shop.productionTimeRemaining = currentQueueEntry.shop.coolDown;
              state.productionQueue.splice(index, 1);
          },
          [types.SET_STRIKE](state, { onStrike, duration }) {
              state.onStrike = onStrike;
              state.strikeDuration = duration;
          },
          [types.UNMUTE](state) {
              state.soundEnabled = true;
          },
          [types.MUTE](state) {
              state.soundEnabled = false;
          },
          [types.TOGGLE_HIDE_APPLIED_UPGRADES](state, hide) {
              state.hideAppliedUpgrades = hide;
          },
          [types.TOGGLE_HIDE_ACHIEVED](state, hide) {
              state.hideAchieved = hide;
          },
          [types.TOGGLE_MUTE](state) {
              state.soundEnabled = !state.soundEnabled;
          },
          [types.SHOW_TOTAL_INCOME_PER_SECOND](state) {
              state.showIncomePerSecond = true;
          },
          [types.USER_LOGIN](state, { user }) {
              state.user = user;
          },
          [types.SET_STATS_ID](state, { id }) {
              state.statsID = id;
          },
          [types.USER_LOGOUT](state) {
              state.user = new User();
          },
          [types.INITIALIZE](state, status) {
              state.isInitialized = status;
          },
          [types.INIT_RESET](state) {
              state.doReset = true;
          }
      };

export default {
    state: stateData,
    getters,
    actions,
    mutations
};
